import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {IHttpClientService, IApiResponse} from "data/services/http";
import {AxiosResponse} from "axios";
import {IUser, IUserProfile, IUserUpdateFields} from "data/types/user";

export interface IAuthApiProvider {
	getSession: (locale: string) => Promise<AxiosResponse<IApiResponse<{user: IUser}>>>;
	getProfile: (locale: string) => Promise<AxiosResponse<IApiResponse<{profile: IUserProfile}>>>;
	updateProfile: (
		locale: string,
		params: IUserUpdateFields
	) => Promise<AxiosResponse<IApiResponse<{profile: IUserProfile}>>>;
}

@injectable()
export class AuthApiProvider implements IAuthApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}
	getSession = (locale: string) => this._http.get<IApiResponse<{user: IUser}>>(`${locale}/user`);

	updateProfile = (locale: string, params: IUserUpdateFields) =>
		this._http.post<IApiResponse<{profile: IUserProfile}>>(`${locale}/profile/save`, params);

	getProfile = (locale: string) =>
		this._http.get<IApiResponse<{profile: IUserProfile}>>(`${locale}/profile`);
}
